import { render } from "./DefaultLayout.vue?vue&type=template&id=65fa480f&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=65fa480f&lang=less"
import "./DefaultLayout.vue?vue&type=style&index=1&id=65fa480f&lang=less&scoped=true"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fa480f"]])

export default __exports__